module.exports = __webpack_public_path__ + "img/saum_rot_candy.bab2d2e9.jpg";